module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ifree-information"
  }, [(_vm.spinShow) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ifree-banner"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.new_banner), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "width": "100%"
      },
      on: {
        "click": function($event) {
          _vm.detail(item.cms_id)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.title))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])]), _vm._v(" "), _vm._l((_vm.new_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "new_list max_width"
    }, [_c('div', {
      staticClass: "new_list_item1"
    }, [_c('a', [_c('img', {
      attrs: {
        "src": item.img
      },
      on: {
        "click": function($event) {
          _vm.detail(item.cms_id)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "new_list_item2"
    }, [_c('h4', {
      on: {
        "click": function($event) {
          _vm.detail(item.cms_id)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('consultation_date')) + ":" + _vm._s(item.add_time))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "pages",
    staticStyle: {
      "margin": "10px",
      "padding-left": "4%"
    }
  }, [_c('page', {
    attrs: {
      "total": _vm.total,
      "length": _vm.limit
    },
    on: {
      "on-change": _vm.refreshData
    }
  })], 1), _vm._v(" "), _c('BackTop', [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/top.png")
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.$t('top_btn')))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/support",
      "target": "_blank"
    }
  }, [_c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 110
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/service.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Service_btn')))])])])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be140f72","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Information.vue
// module id = 847
// module chunks = 0